import { useEffect, useState } from "react";
import CountryCode from "./CountryCode";
import PhoneNumber from "./PhoneNumber";
import styles from "./styles/index.module.css";

function extractNumber(value: string) {
  return value?.replace(/\D/g, "");
}


type PhoneInputProps = {
  phone?: string;
  setPhone?: (val: string) => void;

  country?: string;
  setCountry?: (val: string) => void;

  error?: string;
  setError?: (val: string) => void;

  disableDropdown?: boolean;
  customStyles?: React.CSSProperties;
  inputStyles?: React.CSSProperties;
};
const PhoneInput = ({
  setPhone = () => { },
  country,
  setCountry = () => { },
  phone = "",
  error = "",
  setError = () => { },
  disableDropdown = false,
  customStyles = {},
  inputStyles,
}: PhoneInputProps) => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [number, setNumber] = useState("");



  useEffect(() => {
    if (selectedCountry) {
      const dial = extractNumber(selectedCountry?.dial_code);
      setPhone(`${dial ?? ""}${number ?? ""}`);
    }
  }, [selectedCountry, number]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className={styles.container} style={{ ...customStyles }}>
        <CountryCode
          country={country}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
          setCountry={(obj) => setCountry(obj.alpha3)}
          setNumber={setNumber}
          phone={phone}
          number={number}
          hideIcon={false}
          disabledDropdown={disableDropdown}
        />
        <PhoneNumber
          number={number}
          setNumber={setNumber}
          selectedCountry={selectedCountry}
          setError={setError}
          styles={inputStyles}
        />
      </div>

    </div>
  );
};

export default PhoneInput;
